export const BREAKPOINTS = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1024,
  xxl: 1200,
};

export const COLOR = {
  gold: "#c19d56",
  darkGold: "#a3813c",
  white: "#fff",
  balck: "#000",
  nude: "#ebe7e4",
  darkBrown: "#a9998c",
  lightBrown: "#BAADA3",
  lightYellow: "#FDF8F1",
  red: "#CA0924",
};
